/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AutomaticPauseConfig } from '../models/automatic-pause-config';
import { AutomaticPauseTemplate } from '../models/automatic-pause-template';
import { createAutomaticPauseTemplate } from '../fn/ordering-pauses/create-automatic-pause-template';
import { CreateAutomaticPauseTemplate$Params } from '../fn/ordering-pauses/create-automatic-pause-template';
import { deleteAutomaticPausesConfiguration } from '../fn/ordering-pauses/delete-automatic-pauses-configuration';
import { DeleteAutomaticPausesConfiguration$Params } from '../fn/ordering-pauses/delete-automatic-pauses-configuration';
import { getAllAutomaticPauseTemplates } from '../fn/ordering-pauses/get-all-automatic-pause-templates';
import { GetAllAutomaticPauseTemplates$Params } from '../fn/ordering-pauses/get-all-automatic-pause-templates';
import { getAutomaticPauseTemplate } from '../fn/ordering-pauses/get-automatic-pause-template';
import { GetAutomaticPauseTemplate$Params } from '../fn/ordering-pauses/get-automatic-pause-template';
import { getStoreAutomaticPauseOrderingConfig } from '../fn/ordering-pauses/get-store-automatic-pause-ordering-config';
import { GetStoreAutomaticPauseOrderingConfig$Params } from '../fn/ordering-pauses/get-store-automatic-pause-ordering-config';
import { Pause } from '../models/pause';
import { updateAutomaticPauseTemplate } from '../fn/ordering-pauses/update-automatic-pause-template';
import { UpdateAutomaticPauseTemplate$Params } from '../fn/ordering-pauses/update-automatic-pause-template';
import { upsertChannelOrderingPause } from '../fn/ordering-pauses/upsert-channel-ordering-pause';
import { UpsertChannelOrderingPause$Params } from '../fn/ordering-pauses/upsert-channel-ordering-pause';
import { upsertStoreAutomaticPauseOrderingConfig } from '../fn/ordering-pauses/upsert-store-automatic-pause-ordering-config';
import { UpsertStoreAutomaticPauseOrderingConfig$Params } from '../fn/ordering-pauses/upsert-store-automatic-pause-ordering-config';

@Injectable({ providedIn: 'root' })
export class OrderingPausesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `upsertChannelOrderingPause()` */
  static readonly UpsertChannelOrderingPausePath = '/ordering/pauses';

  /**
   * Upsert channel ordering pause records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertChannelOrderingPause()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertChannelOrderingPause$Response(params: UpsertChannelOrderingPause$Params, context?: HttpContext): Observable<StrictHttpResponse<Pause>> {
    return upsertChannelOrderingPause(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert channel ordering pause records.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertChannelOrderingPause$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertChannelOrderingPause(params: UpsertChannelOrderingPause$Params, context?: HttpContext): Observable<Pause> {
    return this.upsertChannelOrderingPause$Response(params, context).pipe(
      map((r: StrictHttpResponse<Pause>): Pause => r.body)
    );
  }

  /** Path part for operation `getStoreAutomaticPauseOrderingConfig()` */
  static readonly GetStoreAutomaticPauseOrderingConfigPath = '/stores/{storeId}/automatic-pauses';

  /**
   * Returns the automatic pause ordering configuration for a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStoreAutomaticPauseOrderingConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreAutomaticPauseOrderingConfig$Response(params: GetStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseConfig>> {
    return getStoreAutomaticPauseOrderingConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the automatic pause ordering configuration for a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStoreAutomaticPauseOrderingConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreAutomaticPauseOrderingConfig(params: GetStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<AutomaticPauseConfig> {
    return this.getStoreAutomaticPauseOrderingConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutomaticPauseConfig>): AutomaticPauseConfig => r.body)
    );
  }

  /** Path part for operation `upsertStoreAutomaticPauseOrderingConfig()` */
  static readonly UpsertStoreAutomaticPauseOrderingConfigPath = '/stores/{storeId}/automatic-pauses';

  /**
   * Upsert store automatic pause ordering configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertStoreAutomaticPauseOrderingConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertStoreAutomaticPauseOrderingConfig$Response(params: UpsertStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseConfig>> {
    return upsertStoreAutomaticPauseOrderingConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert store automatic pause ordering configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertStoreAutomaticPauseOrderingConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertStoreAutomaticPauseOrderingConfig(params: UpsertStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<AutomaticPauseConfig> {
    return this.upsertStoreAutomaticPauseOrderingConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutomaticPauseConfig>): AutomaticPauseConfig => r.body)
    );
  }

  /** Path part for operation `deleteAutomaticPausesConfiguration()` */
  static readonly DeleteAutomaticPausesConfigurationPath = '/stores/{storeId}/automatic-pauses/{configurationType}';

  /**
   * Deletes an automatic pauses configuration for a store channel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAutomaticPausesConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAutomaticPausesConfiguration$Response(params: DeleteAutomaticPausesConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAutomaticPausesConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an automatic pauses configuration for a store channel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAutomaticPausesConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAutomaticPausesConfiguration(params: DeleteAutomaticPausesConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deleteAutomaticPausesConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllAutomaticPauseTemplates()` */
  static readonly GetAllAutomaticPauseTemplatesPath = '/ordering/automatic-pause-templates';

  /**
   * Gets all automatic order pause templates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAutomaticPauseTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAutomaticPauseTemplates$Response(params: GetAllAutomaticPauseTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AutomaticPauseTemplate>>> {
    return getAllAutomaticPauseTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all automatic order pause templates.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAutomaticPauseTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAutomaticPauseTemplates(params: GetAllAutomaticPauseTemplates$Params, context?: HttpContext): Observable<Array<AutomaticPauseTemplate>> {
    return this.getAllAutomaticPauseTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AutomaticPauseTemplate>>): Array<AutomaticPauseTemplate> => r.body)
    );
  }

  /** Path part for operation `createAutomaticPauseTemplate()` */
  static readonly CreateAutomaticPauseTemplatePath = '/ordering/automatic-pause-templates';

  /**
   * Creates an automatic order pause template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAutomaticPauseTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAutomaticPauseTemplate$Response(params: CreateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
    return createAutomaticPauseTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an automatic order pause template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAutomaticPauseTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAutomaticPauseTemplate(params: CreateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<AutomaticPauseTemplate> {
    return this.createAutomaticPauseTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutomaticPauseTemplate>): AutomaticPauseTemplate => r.body)
    );
  }

  /** Path part for operation `getAutomaticPauseTemplate()` */
  static readonly GetAutomaticPauseTemplatePath = '/ordering/automatic-pause-templates/{templateId}';

  /**
   * Gets automatic order pause template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAutomaticPauseTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomaticPauseTemplate$Response(params: GetAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
    return getAutomaticPauseTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets automatic order pause template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAutomaticPauseTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomaticPauseTemplate(params: GetAutomaticPauseTemplate$Params, context?: HttpContext): Observable<AutomaticPauseTemplate> {
    return this.getAutomaticPauseTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutomaticPauseTemplate>): AutomaticPauseTemplate => r.body)
    );
  }

  /** Path part for operation `updateAutomaticPauseTemplate()` */
  static readonly UpdateAutomaticPauseTemplatePath = '/ordering/automatic-pause-templates/{templateId}';

  /**
   * Updates and automatic pause template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutomaticPauseTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutomaticPauseTemplate$Response(params: UpdateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
    return updateAutomaticPauseTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates and automatic pause template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAutomaticPauseTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutomaticPauseTemplate(params: UpdateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<AutomaticPauseTemplate> {
    return this.updateAutomaticPauseTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutomaticPauseTemplate>): AutomaticPauseTemplate => r.body)
    );
  }

}
